<template>
    <v-container fluid v-if="display.information">
      <v-row>
        <v-col cols="12" lg="4" md="6">
          <v-card elevation="3" style="background-color: #ededed; padding: 20px;">
            <div style="text-align: center;">
              <h2>TAREAS:</h2>
              <br>
            </div>
            <div v-if="display.task.length == 0" style="text-align: center;">
              <p>Sin tareas asignadas</p>
            </div>
            <div v-for="task in display.task" v-bind:key="task">
              <v-card elevation="3" style="margin: 20px; padding: 10px; background-color: #c4c4c4;">
                <div style="display: flex; align-items: center; margin-bottom: 15px;">
                  <v-chip :color="task.creationAgentColor" variant="flat">
                    <p :style="{color: task.creationAgentFontColor}">{{ task.creationAgentName }}</p>
                  </v-chip>
                  <div style="display: flex; margin-left: auto;">
                    <p style="font-size: small;">{{ $generalFunctions.default.methods.parseDatetimeToDDMMYYYHHMMSS(task.taskCreationDatetime) }}</p>
                    <v-tooltip v-if="task.taskState == 'Tarea asignada'" text="Marcar tarea como completada" location="top">
                      <template v-slot:activator="{ props }">
                        <v-icon @click="completeTask(task.taskID)" v-bind="props" color="warning" style="cursor: pointer; margin-left: 10px;">mdi-check-circle</v-icon>
                      </template>
                    </v-tooltip>
                    <v-tooltip v-else-if="task.taskState == 'Tarea completada'" :text="task.taskState" location="top">
                      <template v-slot:activator="{ props }">
                        <v-icon v-bind="props" color="success" style="cursor: pointer; margin-left: 10px;">mdi-check-circle</v-icon>
                      </template>
                    </v-tooltip>
                  </div>
                </div>
                <p><strong>Tipo de la tarea: </strong>{{ task.taskType }}</p>
                <p v-if="task.taskExpectedDatetime"><strong>Fecha límite: </strong>{{ $generalFunctions.default.methods.parseDatetimeToDDMMYYYHHMMSS(task.taskExpectedDatetime) }}</p>
                <p>"{{ task.taskComment }}"</p>
              </v-card>
            </div>
          </v-card>
        </v-col>
        <v-col cols="12" lg="4" md="6" v-if="display.information.monthSaleByAgentOptions && display.information.monthSaleByAgentSeries">
          <v-card elevation="3" style="background-color: #ededed;">
            <div style="text-align: center; margin-top: 20px;">
              <h2>TOP VENDEDORES:</h2>
            </div>
            <apexchart type="pie" :options="display.information.monthSaleByAgentOptions" :series="display.information.monthSaleByAgentSeries" style="margin: 20px;"></apexchart>
          </v-card>
        </v-col>
        <v-col cols="12" lg="4" md="6" v-if="display.information.monthSaleByAgentOptions && display.information.monthSaleByAgentSeries" >
          <v-card elevation="3" style="background-color: #ededed;">
            <div style="text-align: center; margin-top: 20px;">
              <h2>TOP MENSAJEROS:</h2>
            </div>
            <apexchart type="pie" :options="display.information.monthSaleByAgentOptions" :series="display.information.monthSaleByAgentSeries" style="margin: 20px;"></apexchart>
          </v-card>
        </v-col>

        <v-col cols="12" lg="4" md="6" >
          <v-card elevation="3" style="background-color: #ededed; padding: 20px;">
            <div style="text-align: center;">
              <h2>PRODUCTOS NO VENDIDOS:</h2>
            </div>
            <br>
            <v-data-table-virtual :headers="display.productHeaders" :items="display.information.productNotBilledThisMonth" style="overflow-y: auto; max-height: 400px;">
              <template v-slot:item.productName="{ item }">
                <p>{{ item.productName }}</p>
                <p><strong>{{ item.productSKU }}</strong></p>
              </template>
              <template v-slot:item.productPrice="{ item }">
                <p>₡ {{ item.productPrice.toLocaleString('en-US', {minimumFractionDigits: 0, maximumFractionDigits: 2}) }}</p>
              </template>
            </v-data-table-virtual>
          </v-card>
        </v-col>

        <v-col cols="12" md="6">
          <v-card elevation="3" style="background-color: #ededed; padding: 20px;">
            <div style="text-align: center; display: flex; align-items: center; justify-content: center;">
              <h2>TRASLADOS EN CURSO:</h2>
              <v-icon @click="$generalFunctions.default.methods.navigateTo('/productTransfer')" size="25" color="info" style="margin-left: 10px;">mdi-store</v-icon>
            </div>
            <br>
            <v-data-table-virtual :headers="display.productTransferHeaders" :items="display.information.productTransfer" style="overflow-y: auto; max-height: 400px;">
              <template v-slot:item.productTransferSendDatetime="{ item }">
                <p>{{ $generalFunctions.default.methods.parseDatetimeToDDMMYYYHHMMSS(item.productTransferSendDatetime) }}</p>
              </template>
              <template v-slot:item.sendLocalityName="{ item }">
                <v-chip :color="item.sendLocalityColor" variant="flat">
                  <p :style="{color: item.sendLocalityFontColor}">{{ item.sendLocalityName }}</p>
                </v-chip>
              </template>
              <template v-slot:item.receiveLocalityName="{ item }">
                <v-chip :color="item.receiveLocalityColor" variant="flat">
                  <p :style="{color: item.receiveLocalityFontColor}">{{ item.receiveLocalityName }}</p>
                </v-chip>
              </template>
            </v-data-table-virtual>
          </v-card>
        </v-col>

        <v-col cols="12" lg="6" md="6">
        <v-card elevation="3" style="background-color: #ededed; padding: 20px;">
          <div style="text-align: center; display: flex; align-items: center; justify-content: center;">
            <h2>PRODUCTOS TRASLADABLES:</h2>
          </div>
          <br>
          <v-data-table-virtual :headers="display.productFromOtherLocalityHeaders" :items="display.information.productFromOtherLocality" style="overflow-y: auto; max-height: 400px;">
            <template v-slot:item.productName="{ item }">
              <p>{{ item.productName }}</p>
              <p><strong>{{ item.productSKU }}</strong></p>
            </template>
            <template v-slot:item.stockByLocality="{ item }">
              <div style="display: flex;">
                <div v-for="locality in item.stockByLocality" v-bind:key="locality">
                  <v-tooltip location="top">
                    <template v-slot:activator="{ props }">
                      <v-chip v-bind="props" :color="locality.c" variant="flat" style="margin-left: 10px; cursor: pointer;">
                        <p :style="{color: locality.fc}" style="font-weight: bold;">{{ locality.a }}</p>
                      </v-chip>
                    </template>
                    <p>{{ locality.n }}</p>
                  </v-tooltip>                  
                </div>
              </div>
            </template>
          </v-data-table-virtual>
        </v-card>
        </v-col>
      </v-row>
      
    </v-container>
    <br><br>
</template>

<style scoped>
</style>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'StoreAdminDashboardView',
  inject: ['$generalFunctions'],

  
  data: () => ({

    loader: 
    {
      
    },

    display:
    {
      task: [],
      information: null,
      productHeaders: 
      [
        {key: 'productName', title: 'PRODUCTO'},
        {key: 'productPrice', title: 'PRECIO DE VENTA'},
        {key: 'productStockAmount', title: 'STOCK'}
      ],
      productTransferHeaders: 
      [
        {key: 'productTransferID', title: 'ID'},
        {key: 'productTransferSendDatetime', title: 'FECHA'},
        {key: 'sendLocalityName', title: 'ENVIADO DESDE'},
        {key: 'receiveLocalityName', title: 'ENVIADO A'}
      ],
      productFromOtherLocalityHeaders: 
      [
        {key: 'productName', title: 'PRODUCTO'},
        {key: 'stockByLocality', title: 'OTRAS LOCALIDADES'},
      ],
    },

    localStorage: 
    {
      localityID: null,
      agentID: null
    }

  }),

  watch: {
    
  },

  methods: {
    
    async getLocalStorageData(){
      this.localStorage.localityID = localStorage.getItem('localityID');
      this.localStorage.agentID = localStorage.getItem('agentID');

    },

    async generateChart(){
      this.display.information.monthSaleByAgentSeries = this.display.information.monthSaleByAgent.map(monthSaleByAgent => monthSaleByAgent.saleAmount);
      this.display.information.monthSaleByAgentOptions = 
      {
        chart: 
        {
          type: 'pie',
        },
        labels: this.display.information.monthSaleByAgent.map(monthSaleByAgent => monthSaleByAgent.agentName),
        colors: this.display.information.monthSaleByAgent.map(monthSaleByAgent => monthSaleByAgent.agentColor),
        tooltip: {enabled: false}
      };
    },

    async completeTask(taskID){
      const completeTaskRequestQuery = 
      {
        'taskID': taskID,
        'taskState': 'Tarea completada'
      };
      const completeTaskResult = await this.$generalFunctions.default.methods.executeHttpPostRequest('/task/functions/updateTaskState', completeTaskRequestQuery);
      if (completeTaskResult.success){
        this.$root.notificationDialog.showNotificationDialog({
          'notificationDialogTitle': 'ÉXITO',
          'notificationDialogBody': 'La tarea ha sido marcada como completada exitosamente',
          'notificationDialogColor': 'success',
          'notificationDialogIsPersistent': false
        });
        await this.selectTaskByAgentID();
      } else {
        this.$root.notificationDialog.showNotificationDialog({
          'notificationDialogTitle': 'ERROR',
          'notificationDialogBody': 'Ha ocurrido un error inesperado al marcar la tarea como completada, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema',
          'notificationDialogColor': 'error',
          'notificationDialogIsPersistent': false
        });
      }
    },

    async selectTaskByAgentID(){
      const selectTaskByAssignedAgentIDRequestQuery = 
      {
        'taskAssignedAgentID': this.localStorage.agentID
      }
      const selectTaskByAssignedAgentIDResult = await this.$generalFunctions.default.methods.executeHttpPostRequest('/task/functions/selectTaskByAgentID', selectTaskByAssignedAgentIDRequestQuery);
      if (selectTaskByAssignedAgentIDResult.success){
        this.display.task = selectTaskByAssignedAgentIDResult.result;
      } else {
        this.$root.notificationDialog.showNotificationDialog({
          'notificationDialogTitle': 'ERROR',
          'notificationDialogBody': 'Ha ocurrido un error inesperado al consultar la lista de tareas, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema',
          'notificationDialogColor': 'error',
          'notificationDialogIsPersistent': false
        });
      }
    },

    async selectInformation(){
      const selectInformationRequestQuery =
      {
        'localityID': this.localStorage.localityID
      };
      const selectInformationResult = await this.$generalFunctions.default.methods.executeHttpPostRequest('/dashboard/storeAdmin/functions/selectInformation', selectInformationRequestQuery);
      if (selectInformationResult.success){
        this.display.information = selectInformationResult.result;
        await this.generateChart();
      } else {
        this.$root.notificationDialog.showNotificationDialog({
          'notificationDialogTitle': 'ERROR',
          'notificationDialogBody': 'Ha ocurrido un error inesperado al consultar la información del dashboard, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema',
          'notificationDialogColor': 'error',
          'notificationDialogIsPersistent': false
        });
      }
    },
  
  },

  async mounted(){
    await this.getLocalStorageData();
    this.selectInformation();
    this.selectTaskByAgentID();
  }

});

</script>
